import React, {useMemo, useRef, useState} from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import ExpertReportContent from "../../ProjectReportTabs/ExpertReportContent";
import {submitContainer, submitForm} from "../../../utils/validation";
import {getExpertCardParams} from "../../ProjectReportTabs/UniqueResultsPermsHelper";
import useUserContext from "../../../hooks/useUserContext";
import useToast from "../../../hooks/useToast";
import DraggableModal from '../DraggableModal';

const ModalExpertDecision = ({ show, onClose,decision,onDecisionChange,onConfirm,status}) => {
    const userCtx = useUserContext()
    const addToast = useToast();
    const expertCardParams = useMemo(() => status ? getExpertCardParams(userCtx, status) : true, [status]);
    const formEl = useRef(null)

    const handleIsApprovedChange = (value) => {
        onDecisionChange('isApproved', value);
    };

    const handleRecommendationsChange = ({ target }) => {
        onDecisionChange('recommendations', target.value);
    };

    const handleProtocolChange = ({ target }) => {
        onDecisionChange('protocol', target.value);
    };

    const handleDecisionDateChange = ({ target }) => {
        onDecisionChange('decisionDate', target.value);
    };

    const handleMarkChange = ( target ) => {
        (target>=0 && target <=10) || !target ?  onDecisionChange('mark',target ?? '') : onDecisionChange('mark',decision.mark)
    };

    const handleChangeFiles = (newFiles) => {
        onDecisionChange('decisionFiles',newFiles)
    }

    const handleSubmitForm = (event) => {
        submitContainer(event,formEl)
            .then((result) => {
                return !!result && onConfirm()
            })
            .catch((err) => {
                if (err) addToast.error(err);
            });
    }

    return (
            <DraggableModal show={show} size="lg" headerNode='Решение экспертной группы' onHide={onClose}>
                <div ref={formEl}>

                    <Modal.Body>
                        <ExpertReportContent status={status} readOnly={expertCardParams?.readOnly ?? expertCardParams} canEdit={expertCardParams?.canEdit ?? expertCardParams} decision={decision}  callbacks={{handleIsApprovedChange,handleDecisionDateChange,handleRecommendationsChange,handleProtocolChange,handleMarkChange,handleChangeFiles}}/>
                    </Modal.Body>


                <Modal.Footer>
                    <Button
                        onClick={onClose}
                        variant="outline-secondary"
                    >
                        Отмена
                    </Button>
                    <Button
                        onClick={handleSubmitForm}
                        variant={'primary'}
                    >
                        Сохранить
                    </Button>
                </Modal.Footer>
                </div>
            </DraggableModal>
    );
};

export default ModalExpertDecision;
